export default {

    hcoNumber: "",
    keyStore: "",
    KeyStoreVerification: "",
    clientid: "",
    secretid: "",
    clientSecrets: [],
    files: [],
    applicationId:"",
    savedSucceed:false,
    disableUploadButton:false
};
